import { Container, Typography, Box, Paper } from "@mui/material";

export default function RegisterComplete() {
  return (
    <Container component="main" maxWidth="sm" sx={{ mt: 10, mb: 8 }}>
      <Paper elevation={3} sx={{ p: { xs: 3, sm: 4 }, textAlign: "center" }}>
        <Typography component="h1" variant="h5" gutterBottom>
          仮登録が完了しました
        </Typography>
        <Box sx={{ mt: 2, mb: 1 }}>
          <Typography variant="body1" gutterBottom>
            メールアドレス宛に本登録リンクを送信しました。
          </Typography>
          <Typography variant="body2" color="text.secondary" gutterBottom>
            迷惑メールに分類されている事がありますのでご確認下さい。
          </Typography>
        </Box>
        <Box sx={{ mt: 3 }}>
          <Typography variant="body1">
            こちらの画面を閉じて、本登録のリンクをクリックして新しい画面から詳細登録を行ってください。
          </Typography>
        </Box>
      </Paper>
    </Container>
  );
}
